// JOURNAL セクション — タブ切り替えで ajax から記事一覧 HTML を取得（カルーセル / グリッド）

async function fetchJournalListHtml(url, listSelector) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch journal list: ${response.status}`);
  }

  const html = await response.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const list = doc.querySelector(listSelector);

  if (!list) {
    return null;
  }

  return list.innerHTML;
}

function replaceJournalSlides(splideRoot, listEl, listHtml) {
  const { mount, destroy } = window.cmCardProductSlide || {};

  if (typeof destroy === 'function') {
    destroy(splideRoot);
  }

  listEl.innerHTML = listHtml;

  if (typeof mount === 'function') {
    mount(splideRoot);
  }

  const section = splideRoot.closest('.shopify-section.cm-journal-list');
  if (section) {
    updateJournalSectionEmptyState(section);
  }
}

function updateJournalSectionEmptyState(section) {
  const carousel = section.querySelector('[data-journal-carousel]');
  const listEl = carousel?.querySelector('.splide__list');

  if (!listEl) return;

  const isLoading = carousel.querySelector('.cm-featured-new-item__carousel')?.classList.contains('is-loading');
  if (isLoading) return;

  section.classList.toggle('is-empty', listEl.children.length === 0);
}

function updateJournalFootlink(footlinkEl, button, blogUrl) {
  if (!footlinkEl) return;

  if (button.hasAttribute('data-journal-all')) {
    footlinkEl.textContent = 'すべての記事はこちら';
    footlinkEl.href = blogUrl;
    return;
  }

  const tagHandle = button.dataset.journalTag;
  const tagLabel = button.textContent.trim();

  footlinkEl.textContent = `${tagLabel}の記事はこちら`;
  footlinkEl.href = `${blogUrl}/tagged/${tagHandle}`;
}

function setJournalCarouselLoading(carousel, isLoading) {
  const loadingEl = carousel.querySelector('[data-journal-loading]');
  const carouselInner = carousel.querySelector('.cm-featured-new-item__carousel');

  if (loadingEl) {
    loadingEl.hidden = !isLoading;
  }

  if (carouselInner) {
    carouselInner.classList.toggle('is-loading', isLoading);
  }

  if (isLoading) {
    carousel.setAttribute('aria-busy', 'true');
  } else {
    carousel.removeAttribute('aria-busy');
  }
}

function initJournalCollectionCarousel(section) {
  const carousel = section.querySelector('[data-journal-carousel]');
  const collectionHandle = carousel?.dataset.journalCollectionHandle;

  if (!carousel || !collectionHandle) return;

  const splideRoot = carousel.querySelector('[data-cm-card-product-slide]');
  const listEl = carousel.querySelector('.splide__list');
  const blogUrl = carousel.dataset.journalBlogUrl;
  const articlesCount = carousel.dataset.journalArticlesCount || '10';

  if (!splideRoot || !listEl || !blogUrl) return;

  const url = `${blogUrl}/tagged/${encodeURIComponent(collectionHandle)}?view=ajax-journal&limit=${encodeURIComponent(articlesCount)}`;

  setJournalCarouselLoading(carousel, true);

  fetchJournalListHtml(url, '.splide__list')
    .then((listHtml) => {
      if (listHtml === null) return;
      replaceJournalSlides(splideRoot, listEl, listHtml);
    })
    .catch((error) => {
      console.error('[cm-journal-list]', error);
    })
    .finally(() => {
      setJournalCarouselLoading(carousel, false);
      updateJournalSectionEmptyState(section);
    });
}

function initJournalCarouselTabs(section) {
  const tabGroup = section.querySelector('[data-journal-tabs]');
  const carousel = section.querySelector('[data-journal-carousel]');

  if (!tabGroup || !carousel) return;

  const splideRoot = carousel.querySelector('[data-cm-card-product-slide]');
  const listEl = carousel.querySelector('.splide__list');
  const blogUrl = carousel.dataset.journalBlogUrl;
  const footlinkEl = section.querySelector('[data-journal-footlink] .sectionFootlink__link');
  const articlesCount = carousel.dataset.journalArticlesCount || '10';

  if (!splideRoot || !listEl || !blogUrl) return;

  const buttons = tabGroup.querySelectorAll('.cm-tab-group__button');

  buttons.forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.classList.contains('is-active') || button.disabled) return;

      const tagHandle = button.dataset.journalTag;
      const limitQuery = `limit=${encodeURIComponent(articlesCount)}`;
      const url =
        button.hasAttribute('data-journal-all') || !tagHandle
          ? `${blogUrl}?view=ajax-journal&${limitQuery}`
          : `${blogUrl}/tagged/${tagHandle}?view=ajax-journal&${limitQuery}`;

      buttons.forEach((btn) => {
        btn.disabled = true;
      });
      setJournalCarouselLoading(carousel, true);

      try {
        const listHtml = await fetchJournalListHtml(url, '.splide__list');

        if (listHtml === null) {
          alert('記事一覧を取得できませんでした。');
          return;
        }

        replaceJournalSlides(splideRoot, listEl, listHtml);
        updateJournalFootlink(footlinkEl, button, blogUrl);

        buttons.forEach((btn) => btn.classList.remove('is-active'));
        button.classList.add('is-active');
      } catch (error) {
        console.error('[cm-journal-list]', error);
        alert('記事一覧を取得できませんでした。');
      } finally {
        buttons.forEach((btn) => {
          btn.disabled = false;
        });
        setJournalCarouselLoading(carousel, false);
        updateJournalSectionEmptyState(section);
      }
    });
  });
}

function initJournalGridTabs(section) {
  const tabGroup = section.querySelector('[data-journal-tabs]');
  const grid = section.querySelector('[data-journal-grid]');

  if (!tabGroup || !grid) return;

  const listEl = grid.querySelector('.cm-journal-list__grid-list');
  const blogUrl = grid.dataset.journalBlogUrl;
  const ajaxView = grid.dataset.journalAjaxView || 'ajax-journal-grid';
  const footlinkEl = section.querySelector('[data-journal-footlink] .sectionFootlink__link');

  if (!listEl || !blogUrl) return;

  const buttons = tabGroup.querySelectorAll('.cm-tab-group__button');

  buttons.forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.classList.contains('is-active') || button.disabled) return;

      const tagHandle = button.dataset.journalTag;
      const url =
        button.hasAttribute('data-journal-all') || !tagHandle
          ? `${blogUrl}?view=${ajaxView}`
          : `${blogUrl}/tagged/${tagHandle}?view=${ajaxView}`;

      buttons.forEach((btn) => {
        btn.disabled = true;
      });
      grid.setAttribute('aria-busy', 'true');

      try {
        const listHtml = await fetchJournalListHtml(url, '.cm-journal-list__grid-list');

        if (listHtml === null) {
          alert('記事一覧を取得できませんでした。');
          return;
        }

        listEl.innerHTML = listHtml;
        updateJournalFootlink(footlinkEl, button, blogUrl);

        buttons.forEach((btn) => btn.classList.remove('is-active'));
        button.classList.add('is-active');
      } catch (error) {
        console.error('[cm-journal-list]', error);
        alert('記事一覧を取得できませんでした。');
      } finally {
        buttons.forEach((btn) => {
          btn.disabled = false;
        });
        grid.removeAttribute('aria-busy');
      }
    });
  });
}

function initJournalTabs(section) {
  const tabGroup = section.querySelector('[data-journal-tabs]');

  if (tabGroup?.hasAttribute('data-journal-tabs-links')) return;

  if (section.querySelector('[data-journal-grid]')) {
    initJournalGridTabs(section);
    return;
  }

  if (section.querySelector('[data-journal-carousel]')?.dataset.journalCollectionHandle) {
    initJournalCollectionCarousel(section);
    return;
  }

  initJournalCarouselTabs(section);
  updateJournalSectionEmptyState(section);
}

function initJournalSections(container = document) {
  container.querySelectorAll('.shopify-section.cm-journal-list').forEach(initJournalTabs);
}

document.addEventListener('DOMContentLoaded', () => {
  initJournalSections();
});

document.addEventListener('shopify:section:load', (event) => {
  initJournalSections(event.target);
});
